module.exports = __webpack_public_path__ + "uGMHL94-PyB0HAplpWqScIX0hVgzZQUfRDuZrPvH3D8.efbd91e70690602ac8e7.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/fonts/font-google/uGMHL94-PyB0HAplpWqScIX0hVgzZQUfRDuZrPvH3D8.woff2
// module id = ../../../../../src/assets/fonts/font-google/uGMHL94-PyB0HAplpWqScIX0hVgzZQUfRDuZrPvH3D8.woff2
// module chunks = 40